import React, { FC, useEffect, useRef, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import './style.scss';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import QuestionBox from 'src/components/molecules/content/QuestionBox';
import {
  contentModalDep2ViewStore,
  errorModalViewStore,
  loadingModalViewStore,
} from 'src/store/modal';
import { loanDataStore } from 'src/store/housingfunds/loan';
import { fetchUpdateHouseLoan } from 'src/fetch/stepC/houseLoan';
import { fetchSurveyUpdate } from 'src/fetch/stepC/houseSaving';
import { getMemberInfo } from 'src/utils/common';

interface Props {
  viewType?: string;
}

const Spouse: FC<Props> = ({ viewType }) => {
  const queStyle = { width: '400px' };
  const queSet = {
    question: [
      {
        idx: 0,
        status: 'this',
        confirm: '',
        set: {
          question: '근로소득이 있습니까?',
          style: queStyle,
          desc: {
            style: {},
            data: [
              {
                text: <div className="_text">일용근로자는 '아니오' 선택</div>,
              },
            ],
          },
        },
      },
      {
        idx: 1,
        status: 'ready',
        confirm: '',
        set: {
          question: '주택취득당시 무주택 또는 1주택만 소유한 세대인가요?',
          style: queStyle,
          desc: {
            style: {},
            data: [
              {
                text: <div className="_text">(배우자는 주소를 달리하여도 동일세대로 봄)</div>,
              },
            ],
          },
        },
      },
      {
        idx: 2,
        status: 'ready',
        set: {
          question: '과세기간 종료일(12.31.) 현재 세대주 인가요?',
          style: queStyle,
          desc: {
            style: {},
            data: [
              {
                text: <div className="_text">단독 세대주 포함</div>,
              },
            ],
          },
        },
      },
      {
        idx: 3,
        status: 'ready',
        set: {
          question:
            '과세기간 종료일(12.31.) 현재 무주택 또는 1주택만 소유한 세대요건을 충족하나요?',
          style: queStyle,
          desc: {
            style: {},
            data: [
              {
                text: <div className="_text">(배우자는 주소를 달리하여도 동일세대로 봄)</div>,
              },
            ],
          },
        },
      },
      {
        idx: 4,
        status: 'ready',
        set: {
          question:
            '2024.1.1 이후 주택을 취득하고 취득 당시 해당 주택의 기준시가가 6억원 이하인가요?',
          style: queStyle,
          desc: {
            style: {},
            data: [
              {
                text: (
                  <div className="_text">
                    13.12.31. 이전 차입시 : 주택취득 당시 기준시가 3억원 이하
                  </div>
                ),
              },
              {
                text: (
                  <div className="_text">
                    14.1.1. - 18.12.31. 차입시 : 주택취득 당시 기준시가 4억원 이하
                  </div>
                ),
              },
              {
                text: (
                  <div className="_text">
                    19.1.1. - 23.12.31. 차입시 : 주택취득 당시 기준시가 5억원 이하
                  </div>
                ),
              },
            ],
          },
        },
      },
      {
        idx: 5,
        status: 'ready',
        set: {
          question: '주택소유권이전(보존)등기일로부터 3개월 이내에 차입하였나요?',
          style: queStyle,
          desc: {
            style: {},
            data: [],
          },
        },
      },
      {
        idx: 6,
        status: 'ready',
        set: {
          question: '근로자 본인 소유주택으로 본인 명의로 차입하였나요?',
          style: queStyle,
          desc: {
            style: {},
            data: [],
          },
        },
      },
    ],
    answer: {
      status: 'ready',
      set: {
        title: '주택공제를 받을 수 있습니다.',
        status: 'yes',
        desc: {
          style: {},
          data: [
            {
              // text: (
              //   <div className="_text">이때, 총 급여액은 비과세 소득을 제외한 금액을 말합니다.</div>
              // ),
            },
          ],
        },
      },
    },
  };

  const [queState, setQueState] = useState({ set: queSet.question });
  const [awsState, setAwsState] = useState({ set: queSet.answer });

  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const loadingState = loadingModalViewStore((state: any) => state.set);
  const setContentModalDep2State = contentModalDep2ViewStore((state: any) => state.set);
  const userInfoData: any = getMemberInfo();

  const loanList = loanDataStore((state: any) => state.result).data || [];
  const bindStoreParam = loanDataStore((state: any) => state.param);
  const bindStoreBindParam = loanDataStore((state: any) => state.bindParam);

  const confirmEvent = async () => {
    // for (const item of loanList) {
    //   const param = {
    //     ...item,
    //     acct_year: userInfoData.acct_year,
    //     co_cd: userInfoData.co_cd,
    //     co_id: userInfoData.co_id,
    //     question_status: 'Y',
    //   };
    //   await fetchUpdateHouseLoan(param, queryClient, errorModalState, loadingState, () => {});
    // }
    const answerStatus = awsState.set.set.status === 'no' ? 'X' : 'Y';
    for (const item of loanList) {
      const param = {
        // ...item,
        in_data_seqid: item.in_data_seqid,
        house_type: 'loan',
        acct_year: userInfoData.acct_year,
        co_cd: userInfoData.co_cd,
        co_id: userInfoData.co_id,
        question_status: answerStatus,
      };
      await fetchSurveyUpdate(param, queryClient, errorModalState, loadingState, () => {});
    }
    const initialSeq = bindStoreParam.initialSeq || 0;
    bindStoreBindParam({ initialSeq: initialSeq + 1 });
    setContentModalDep2State({ active: '', content: null });
  };

  useEffect(() => {
    const queEndStatus = queState.set.filter((item: any) => item.status !== 'end');
    const queConfirmStatus = queState.set.filter((item: any) => item.confirm === 'yes');

    if (queEndStatus.length === 0) {
      awsState.set.status = 'end';
      if (queState.set.length !== queConfirmStatus.length) {
        awsState.set.set.title = '주택공제를 받을 수 없습니다.';
        awsState.set.set.status = 'no';
      } else {
        awsState.set.set.title = '주택공제를 받을 수 있습니다.';
        awsState.set.set.status = 'yes';
      }

      setAwsState({ set: awsState.set });
    } else {
      awsState.set.status = 'ready';
      setAwsState({ set: awsState.set });
    }
  }, [queState]);

  return (
    <div className="_spouse_question_div">
      <div className="que_box">
        <QuestionBox
          queSet={queSet}
          queState={queState}
          setQueState={setQueState}
          awsState={awsState}
          setAwsState={setAwsState}
        />
      </div>
      {awsState.set.status === 'end' ? (
        <div className="_confirm_btn_div">
          <DefaultButton
            text="확인"
            clickEvent={e => confirmEvent()}
            styleDef={{ fontSize: '13px', width: '210px', height: '38px' }}
            type="type5"
          />
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Spouse;
